module.exports = __webpack_public_path__ + "static/media/step_into.f35aa916.png";